import $ from 'jquery'
import React from 'react'


function Selector({choices, value, onClick}) {

    return (
        <div className={"selector"}>
            {choices.map((choice, i) => (
                <div
                    key={i}
                    className={"choice" + (choice===value?" selected": "")}
                    onClick={(e)=>{ e.preventDefault(); if (onClick) { onClick(choice); }}}
                >{choice}</div>
            ))}
        </div>
    );
}

export default Selector


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/Selector.js